<template>
  <el-table :data="tableData" style="width: 100%">
    <el-table-column prop="date" label="赠品编码" width="180" />
    <el-table-column prop="name" label="赠品名称" width="180" />
    <el-table-column prop="address" label="赠品数量" />
    <el-table-column prop="address" label="赠品图片" />
  </el-table>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ]
    }
  }
}
</script>
